import React from 'react'

const ListDetailsCard = ({ listData }) => {
  return (
    <div className='grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 mt-2 border bg-gray-100 border-gray-100 p-2 rounded pt-4'>
      {listData?.map((data, index) => (
        <div className='mb-2 md:mb-2' key={index}>
          <h5 className='text-12-gray mb-1'>{data?.label}</h5>
          <h4 className='text-14-dark !font-semibold capitalize'>{data?.text}</h4>
        </div>
      ))}
    </div>
  )
}

export default ListDetailsCard
